import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ErrorResponse } from '@core/models';

export const exchangeRatesActions = createActionGroup({
  source: 'exchange-rates',
  events: {
    getCurrencyPairsRequest: emptyProps(),
    getCurrencyPairsSuccess: props<{ lee?: number; cheelee?: number }>(),
    getCurrencyPairsFailure: props<{ error: ErrorResponse }>(),
  },
});
